import { makeStyles } from "tss-react/mui";
import { EDeviceType, getThemeBreakpointByDeviceType } from "@utils/getThemeBreakpointByDeviceType";

export const useStyle = makeStyles()((theme) => ({
    container: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(7),
        justifyContent: "center",
        padding: theme.spacing(7, 2),
        maxWidth: 1280,
        margin: "0 auto",
        [getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE_OR_TABLET)]: {
            width: "auto",
        },
        [getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE)]: {
            maxWidth: 600,
        },
    },
    blockContainer: {
        display: "flex",
        gap: theme.spacing(4),
        [getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE_OR_TABLET)]: {
            flexDirection: "column",
        },
    },
}));
